// extracted by mini-css-extract-plugin
export default {"modal":"PurchaseSuccess_modal__EdYnn","title":"PurchaseSuccess_title__Ic+7P","button":"PurchaseSuccess_button__qrgd+"};